import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { fetchAutomationTaskResult } from './automationResultService.js';
import './AutomationResultPage.css';
import AudioComponent from '@/components/AudioComponent.js';
import ImageAndVideoComponent from '@/components/ImageAndVideoComponent.js';
import TextInput from '@/components/TextInput.js';
import TaskStatusTracker from './components/TaskStatusTracker.js';

export const AutomationResultPage = () => {
  const { client_id } = useParams();
  const [taskResult, setTaskResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchAutomationTaskResult(client_id);
        setTaskResult(result);
      } catch (err) {
        setError('无法获取任务结果，请稍后再试。');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [client_id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const handleDownload = async (files, audio_type) => {
  //   try {
  //     const audioUrls = files.map((file) => file.audio_AI_url);
  //     const file = await downloadAudio(
  //       audioUrls,
  //       client_id,
  //       audio_type,
  //       taskResult.batch_id
  //     );
  //     const url = file.data.mergedAudioUrl;
  //     if (audio_type !== '2') {
  //       setTaskResult((prev) => ({
  //         ...prev,
  //         merged_narrator_audios: url,
  //       }));
  //     } else {
  //       setTaskResult((prev) => ({
  //         ...prev,
  //         merged_deceased_audios: url,
  //       }));
  //     }
  //   } catch (error) {
  //     console.error('下载失败:', error);
  //   }
  // };

  if (isLoading) {
    return <div>加载中...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <div className="automation-task-result-page">
        <TaskStatusTracker client_id={client_id} />
        <div className="automation-task-result">
          <h2>订单自动化流程结果</h2>

          {taskResult && (
            <>
              <section>
                <TextInput
                  key={0}
                  name={'speech_text'}
                  label={'致辞'}
                  type="textarea"
                  value={taskResult.text.speech_text}
                  disabled={true}
                  style={{ minHeight: '7rem' }}
                  required={false}
                />
              </section>

              <section>
                <TextInput
                  key={0}
                  name={'farewell_text'}
                  label={'告别'}
                  type="textarea"
                  value={taskResult.text.farewell_text}
                  disabled={true}
                  style={{ minHeight: '7rem' }}
                  required={false}
                />
              </section>

              <section>
                <h2>生成的文本和对应的音频</h2>
                {taskResult.audios.narrator_audios.length > 0 && (
                  <>
                    <div className="audio-title-container">
                      <h2>致辞</h2>
                    </div>
                    {/* {taskResult.merged_narrator_audios &&
                  taskResult.merged_narrator_audios[0] ? (
                    <>
                      <div>合并后告别音频</div>
                      <AudioComponent
                        audio={taskResult.merged_narrator_audios[0]}
                        client_id={client_id}
                      />
                    </>
                  ) : (
                    <div className="download-btn-container">
                      <Button
                        variant="primary"
                        className="download-button-audio-component"
                        onClick={() =>
                          handleDownload(taskResult.audios.narrator_audios, '1')
                        }
                      >
                        下载
                      </Button>
                    </div>
                  )} */}
                    {taskResult.audios.narrator_audios.map((audio) => (
                      <AudioComponent
                        index={audio.id}
                        audio={audio}
                        client_id={client_id}
                        audio_text_type={audio.text_type}
                        batch_id={taskResult.batch_id}
                      />
                    ))}
                  </>
                )}
                {taskResult.audios.deceased_audios.length > 0 && (
                  <>
                    <div className="audio-title-container">
                      <h2>告别</h2>
                    </div>
                    {/* {taskResult.merged_deceased_audios &&
                  taskResult.merged_deceased_audios[0] ? (
                    <>
                      <div>合并后告别音频</div>
                      <AudioComponent
                        audio={taskResult.merged_deceased_audios[0]}
                        client_id={client_id}
                      />
                    </>
                  ) : (
                    <div className="download-btn-container">
                      <Button
                        variant="primary"
                        className="download-button-audio-component"
                        onClick={() =>
                          handleDownload(taskResult.audios.deceased_audios, '2')
                        }
                      >
                        下载
                      </Button>
                    </div>
                  )} */}
                    {taskResult.audios.deceased_audios.map((audio) => (
                      <AudioComponent
                        index={audio.id}
                        audio={audio}
                        client_id={client_id}
                        audio_text_type={audio.text_type}
                        batch_id={taskResult.batch_id}
                      />
                    ))}
                  </>
                )}
                <AudioComponent
                  index={'blank'}
                  client_id={client_id}
                  blank={true}
                  batch_id={taskResult.batch_id}
                />
              </section>

              <section>
                <h2>用户上传的图片和处理后得到的对应结果</h2>
                {taskResult.videos.map((pair) => (
                  <ImageAndVideoComponent index={pair.id} pair={pair} />
                ))}
                {taskResult.originalImages.map((pair) => (
                  <ImageAndVideoComponent index={pair.id} pair={pair} />
                ))}
              </section>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AutomationResultPage;
